<p class="italic">
  Dashboard Dyslexia is a piece of art made by artist Pandelune. It is Work In Progress: not finished, and not published for minting.
</p>
